import React from 'react';
import { Modal, Button } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const CustomModal = styled(Modal)`
	.ant-modal-content {
		border-radius: 4px;
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
		padding: 0;
		text-align: center;
		padding-inline: 50px;
	}
	.ant-modal-body {
		padding: 0;
	}
`;

const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 28px;
	padding: 0px 0px 24px;
`;

const UpperContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 24px;
	padding: 20px 0px 0px;
	width: 100%;
`;

const QuestionIcon = styled.div`
	svg {
		width: 48px;
		height: 48px;
	}
`;

// SuccessIcon removed as it's not used

const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	align-self: stretch;
	gap: 13px;
`;

const MessageText = styled.p`
	font-family: Inter, sans-serif;
	font-weight: 600;
	font-size: 16px;
	line-height: 1.25em;
	text-align: center;
	color: #000000;
	margin: 0;
`;

const QuestionText = styled.p`
	font-family: Inter, sans-serif;
	font-weight: 400;
	font-size: 16px;
	line-height: 1.25em;
	text-align: center;
	color: #000000;
	margin: 0;
`;

const ActionButtons = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 28px;
	width: 100%;
	padding: 0 30px;
`;

const SecondaryButton = styled(Button)`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
	padding: 8px 16px;
	width: 135.5px;
	height: 40px;
	border-radius: 2px;
	border: 0.5px solid #173c58;
	color: #173c58;
	font-family: Inter, sans-serif;
	font-weight: 500;
	font-size: 16px;
	line-height: 1.21em;
	background: #ffffff;
`;

const PrimaryButton = styled(Button)`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
	padding: 8px 16px;
	width: 135.5px;
	height: 40px;
	border-radius: 2px;
	background: #143e60;
	color: #ffffff;
	font-family: Inter, sans-serif;
	font-weight: 500;
	font-size: 16px;
	line-height: 1.21em;
	border: none;
`;

// Modal 1: Simple Success Message
// eslint-disable-next-line react/no-multi-comp
export function SimpleSuccessModal({ visible, onClose, message = 'Trip Created successfully' }) {
	return (
		<CustomModal
			open={visible}
			onCancel={onClose}
			footer={null}
			closable={false}
			style={{ top: 200 }}
			width={488}
		>
			<ModalContainer>
				<UpperContent>
					<TextContainer>
						<MessageText>{message}</MessageText>
					</TextContainer>
				</UpperContent>
			</ModalContainer>
		</CustomModal>
	);
}

// Modal 2: Success with Action Buttons
// eslint-disable-next-line react/no-multi-comp
export function SuccessWithActionsModal({
	visible,
	onClose,
	message = 'LR Created successfully',
	primaryButtonText = 'View LR',
	secondaryButtonText = 'View trips',
	onPrimaryClick,
	onSecondaryClick,
}) {
	return (
		<CustomModal
			open={visible}
			onCancel={onClose}
			footer={null}
			closable={false}
			style={{ top: 200 }}
			width={488}
		>
			<ModalContainer>
				<UpperContent>
					<TextContainer>
						<MessageText>{message}</MessageText>
					</TextContainer>
				</UpperContent>
				<ActionButtons>
					<SecondaryButton onClick={onSecondaryClick}>
						{secondaryButtonText}
					</SecondaryButton>
					<PrimaryButton type="primary" onClick={onPrimaryClick}>
						{primaryButtonText}
					</PrimaryButton>
				</ActionButtons>
			</ModalContainer>
		</CustomModal>
	);
}

// Modal 3: Question with Yes/No
// eslint-disable-next-line react/no-multi-comp
export function QuestionModal({
	visible,
	onClose,
	question = 'Do you want to create trip without LR ?',
	onYes,
	onNo,
}) {
	return (
		<CustomModal
			open={visible}
			onCancel={onClose}
			footer={null}
			closable={false}
			style={{ top: 200 }}
			width={488}
		>
			<ModalContainer>
				<UpperContent>
					<QuestionIcon>
						<svg
							width="48"
							height="48"
							viewBox="0 0 48 48"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle cx="24" cy="24" r="24" fill="#143e60" />
							<path
								d="M24 8C15.163 8 8 15.163 8 24C8 32.837 15.163 40 24 40C32.837 40 40 32.837 40 24C40 15.163 32.837 8 24 8ZM26 34H22V30H26V34ZM26 26H22V14H26V26Z"
								fill="white"
							/>
						</svg>
					</QuestionIcon>
					<TextContainer>
						<QuestionText>{question}</QuestionText>
					</TextContainer>
				</UpperContent>
				<ActionButtons>
					<SecondaryButton onClick={onNo}>No</SecondaryButton>
					<PrimaryButton type="primary" onClick={onYes}>
						Yes
					</PrimaryButton>
				</ActionButtons>
			</ModalContainer>
		</CustomModal>
	);
}

// Modal 4: POD Upload Question
// eslint-disable-next-line react/no-multi-comp, sonarjs/no-identical-functions
export function PodUploadQuestionModal({
	visible,
	onClose,
	question = 'Do you want to Upload POD without LR ?',
	onYes,
	onNo,
}) {
	return (
		<CustomModal
			open={visible}
			onCancel={onClose}
			footer={null}
			closable={false}
			style={{ top: 200 }}
			width={488}
		>
			<ModalContainer>
				<UpperContent>
					<QuestionIcon>
						<svg
							width="48"
							height="48"
							viewBox="0 0 48 48"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle cx="24" cy="24" r="24" fill="#143e60" />
							<path
								d="M24 8C15.163 8 8 15.163 8 24C8 32.837 15.163 40 24 40C32.837 40 40 32.837 40 24C40 15.163 32.837 8 24 8ZM26 34H22V30H26V34ZM26 26H22V14H26V26Z"
								fill="white"
							/>
						</svg>
					</QuestionIcon>
					<TextContainer>
						<QuestionText>{question}</QuestionText>
					</TextContainer>
				</UpperContent>
				<ActionButtons>
					<SecondaryButton onClick={onNo}>No</SecondaryButton>
					<PrimaryButton type="primary" onClick={onYes}>
						Yes
					</PrimaryButton>
				</ActionButtons>
			</ModalContainer>
		</CustomModal>
	);
}

// PropTypes for all modals
SimpleSuccessModal.propTypes = {
	visible: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	message: PropTypes.string,
};

SuccessWithActionsModal.propTypes = {
	visible: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	message: PropTypes.string,
	primaryButtonText: PropTypes.string,
	secondaryButtonText: PropTypes.string,
	onPrimaryClick: PropTypes.func.isRequired,
	onSecondaryClick: PropTypes.func.isRequired,
};

QuestionModal.propTypes = {
	visible: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	question: PropTypes.string,
	onYes: PropTypes.func.isRequired,
	onNo: PropTypes.func.isRequired,
};

PodUploadQuestionModal.propTypes = {
	visible: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	question: PropTypes.string,
	onYes: PropTypes.func.isRequired,
	onNo: PropTypes.func.isRequired,
};

export default {
	SimpleSuccessModal,
	SuccessWithActionsModal,
	QuestionModal,
	PodUploadQuestionModal,
};
